import { render, staticRenderFns } from "./editAddressDialog.vue?vue&type=template&id=519bb677&scoped=true"
import script from "./editAddressDialog.vue?vue&type=script&lang=js"
export * from "./editAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./editAddressDialog.vue?vue&type=style&index=0&id=519bb677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bb677",
  null
  
)

export default component.exports